//
//
//
//
//
//

import { Topic } from "@/models";
import TopicItem from "@/components/topic/TopicItem.vue";

export default {
  name: "FeihuaTopics",
  created() {
    this.getData();
  },
  scrollBottom() {
    this.getData(this.page + 1);
  },
  metaInfo() {
    return {
      title: "飞花令"
    };
  },
  props: [],
  data() {
    return {
      topics: [],
      page: 1,
      loading: false
    };
  },
  methods: {
    getData(page = 1) {
      this.loading = true;

      Topic.getFeihuaTopics(page)
        .then(topics => {
          if (page == 1) {
            this.topics = topics;
          } else {
            this.topics = this.topics.concat(topics);
          }

          this.loading = false;
          this.page = page;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  components: {
    TopicItem
  }
};



// WEBPACK FOOTER //
// ./src/pages/FeihuaTopics.vue